// UpgradeRequiredPage.js
import React from "react"
import { useLocation, useNavigate } from "react-router-dom"

export default function UpgradeRequiredPage() {
  const location = useLocation()
  const navigate = useNavigate()
  const params = new URLSearchParams(location.search)
  const feature = params.get("feature") || "advanced analytics"

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem",
        background: "#f8fafc",
      }}
    >
      <div
        style={{
          maxWidth: "520px",
          background: "#ffffff",
          borderRadius: "16px",
          padding: "3rem 2.5rem",
          textAlign: "center",
          border: "1px solid #e2e8f0",
          boxShadow: "0 10px 25px rgba(0,0,0,0.05)",
        }}
      >
        <div
          style={{
            fontSize: "2.25rem",
            marginBottom: "1rem",
          }}
        >
          🔒
        </div>

        <h1
          style={{
            fontSize: "1.375rem",
            fontWeight: 700,
            color: "#0f172a",
            marginBottom: "0.75rem",
          }}
        >
          Feature Not Available
        </h1>

        <p
          style={{
            fontSize: "0.95rem",
            lineHeight: 1.6,
            color: "#64748b",
            marginBottom: "1.75rem",
          }}
        >
          <b>{feature}</b> is not available on selected plans.  
          Upgrade to unlock detailed insights, deeper analytics, and
          enhanced tracking across your links.
        </p>

        <button
          onClick={() => navigate("/")}
          style={{
            background: "#0d6efd",
            color: "#ffffff",
            border: "none",
            padding: "0.75rem 1.75rem",
            borderRadius: "10px",
            fontSize: "0.95rem",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          View Plans & Upgrade
        </button>

        <p
          style={{
            marginTop: "1.25rem",
            fontSize: "0.75rem",
            color: "#94a3b8",
          }}
        >
          Plan availability may vary by feature
        </p>
      </div>
    </div>
  )
}